export default __webpack_public_path__ + "static/media/illu-camion.ea139db6.png";